<template>
    <div class="wizard__wrap">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>

            <div class="wizard__block-title">
                Please record information about SOW
            </div>

            <div class="wizard__block-sow">
                <div class="row jus-c--space-between">
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <div class="form-field form-field--text">
                            <label for="sow_title"
                                >Title<span class="red">*</span></label
                            >
                            <input
                                type="text"
                                id="sow_title"
                                v-model="new_sow.title"
                                name="sow_title"
                            />
                            <span
                                class="error"
                                style="left: 0"
                                v-if="errors.title"
                                >{{ errors.title }}</span
                            >
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div
                            class="form-field form-field--datepicker"
                            ref="datepicker"
                        >
                            <label for="sow_date"
                                >Activation date<span class="red"
                                    >*</span
                                ></label
                            >
                            <input
                                type="text"
                                id="sow_date"
                                v-model="new_sow.date"
                                name="sow_date"
                                @changeDate="onChangeDatePicker"
                            />
                            <span
                                class="error"
                                style="left: 0"
                                v-if="errors.date"
                                >{{ errors.date }}</span
                            >
                            <button type="button" class="btn btn--icon">
                                <i class="icon icon-calendar"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    class="row jus-c--space-between"
                    style="margin-bottom: 40px"
                >
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <div class="row type-row">
                            <div class="col-lg-12 col-md-12">
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="margin-bottom: 16px"
                                >
                                    <input
                                        type="radio"
                                        name="is_new_deal"
                                        id="is_new_deal_false"
                                        :checked="!is_new_deal"
                                        @change="is_new_deal = false"
                                    />
                                    <label for="is_new_deal_false"
                                        >Current deal
                                        <span
                                            style="top: 0"
                                            class="tooltip-btn"
                                            data-message="Select this if the legal terms remain unchanged, but a new SOW has been signed"
                                            >?</span
                                        ></label
                                    >
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        name="is_new_deal"
                                        id="is_new_deal_true"
                                        :checked="is_new_deal"
                                        @change="is_new_deal = true"
                                    />
                                    <label for="is_new_deal_true"
                                        >Create new deal
                                        <span
                                            style="top: 0"
                                            class="tooltip-btn"
                                            data-message="Select this if new or updated legal terms have been signed along with a new SOW"
                                            >?</span
                                        ></label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div
                            class="form-field form-field--datepicker"
                            ref="valid_datepicker"
                        >
                            <label for="valid_date">Valid until</label>
                            <input
                                type="text"
                                id="valid_date"
                                v-model="new_sow.valid_date"
                                name="valid_date"
                                @changeDate="onChangeValidDatePicker"
                            />
                            <span
                                class="error"
                                style="left: 0"
                                v-if="errors.valid_date"
                                >{{ errors.valid_date }}</span
                            >
                            <button type="button" class="btn btn--icon">
                                <i class="icon icon-calendar"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row type-row">
                    <div
                        class="col-lg-12 col-md-12"
                        style="margin-bottom: 24px"
                    >
                        <div class="form-field form-field--radiobutton">
                            <input
                                type="radio"
                                name="is_has_signed_sow"
                                id="is_has_signed_sow_true"
                                :checked="is_has_signed_sow == 'yes'"
                                @change="is_has_signed_sow = 'yes'"
                            />
                            <label for="is_has_signed_sow_true"
                                >I have signed SOW</label
                            >
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div
                            class="new-sow-form row"
                            style="padding-left: 40px"
                        >
                            <div
                                class="col-xl-2 col-lg-2 col-md-2"
                                style="padding-top: 12px"
                            >
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        name="is_file"
                                        id="is_file_true"
                                        :checked="
                                            is_file_option &&
                                            is_file_option !== 'later'
                                        "
                                        @change="is_file_option = true"
                                    />
                                    <label for="is_file_true">File</label>
                                </div>
                            </div>
                            <div class="col-xl-10 col-lg-10 col-md-10">
                                <div
                                    class="form-field form-field--file"
                                    ref="filepicker"
                                >
                                    <input
                                        type="file"
                                        id="agreement"
                                        :disabled="!is_file_option_computed"
                                        name="agreement"
                                        hidden
                                        ref="fileInput"
                                        @input="pickFile"
                                        @change="pickFile"
                                    />
                                    <button type="button" class="btn btn--file">
                                        File
                                        <i class="icon icon-plus"></i>
                                    </button>
                                    <span
                                        class="filename"
                                        v-if="new_sow.filename"
                                        >{{ new_sow.filename }}</span
                                    >
                                    <span
                                        class="error"
                                        style="left: 0"
                                        v-if="errors.file"
                                        >{{ errors.file }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div
                            class="row new-sow-form"
                            style="padding-left: 40px"
                        >
                            <div
                                class="col-xl-2 col-lg-2 col-md-2"
                                style="padding-top: 12px"
                            >
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        name="is_file"
                                        id="is_file_false"
                                        :checked="!is_file_option"
                                        @change="is_file_option = false"
                                    />
                                    <label for="is_file_false">URL</label>
                                </div>
                            </div>
                            <div class="col-xl-10 col-lg-10 col-md-10">
                                <div class="form-field form-field--text">
                                    <input
                                        type="text"
                                        id="sow_url"
                                        :disabled="is_file_option_computed"
                                        v-model="new_sow.url"
                                        name="sow_url"
                                    />
                                    <span
                                        class="error"
                                        style="left: 0"
                                        v-if="errors.url"
                                        >{{ errors.url }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12" style="padding-left: 40px">
                        <div class="form-field form-field--radiobutton">
                            <input
                                type="radio"
                                name="is_upload_later"
                                id="is_upload_later"
                                :checked="is_file_option === 'later'"
                                @change="is_file_option = 'later'"
                            />
                            <label for="is_upload_later">Upload it later</label>
                        </div>
                    </div>
                </div>
                <div class="row type-row">
                    <div class="col-lg-12 col-md-12">
                        <div class="form-field form-field--radiobutton">
                            <input
                                type="radio"
                                name="is_has_signed_sow"
                                id="is_has_signed_sow_false"
                                :checked="is_has_signed_sow === 'no'"
                                @change="is_has_signed_sow = 'no'"
                            />
                            <label for="is_has_signed_sow_false"
                                >I don't have signed SOW. Please explain
                                why</label
                            >
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div class="row" style="padding-left: 40px">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="form-field form-field--textarea">
                                    <label for="explanation">Explanation</label>
                                    <textarea
                                        id="explanation"
                                        :disabled="is_has_signed_sow !== 'no'"
                                        v-model="description"
                                        name="explanation"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button
                    @click="
                        () =>
                            onChangeSection(
                                SECTIONS.DO_YOU_HAVE_UPSELL,
                                SECTIONS.EDIT_SALE_LINE_ITEM
                            )
                    "
                    class="btn btn--prev btn--white"
                >
                    Previous
                </button>
                <button
                    @click="onSaveSow"
                    class="btn btn--next btn--gray"
                    v-if="
                        (is_has_signed_sow === 'yes' &&
                            ((is_file_option && new_sow.filename) ||
                                (!is_file_option && new_sow.url))) ||
                        (is_has_signed_sow === 'no' &&
                            description.length >= 5) ||
                        is_file_option === 'later'
                    "
                >
                    Next
                </button>
            </div>
            <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader";

import { Datepicker } from "vanillajs-datepicker";
import { SECTIONS } from "../consts";
import axios from "axios";
import { scrollToTop } from "../../../helpers/_scrollToTop";
import { reInitAllTooltips } from "../../../helpers/_tooltip";

export default {
    name: "Wizard_SOW",
    props: ["onChangeSection"],
    components: {
        ClipLoader,
    },
    data() {
        return {
            SECTIONS,
            isLoading: false,
            is_has_signed_sow: "yes",
            sow_selected: null,
            new_sow: {
                title: "",
                date: "",
                file: null,
                url: "",
                filename: "",
                valid_date: "",
            },
            description: "",
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
                autohide: true,
            },
            is_file_option: true,
            is_upload_later: false,
            errors: {
                title: null,
                date: null,
                valid_date: null,
                file: null,
                url: null,
                type: null,
                description: null,
            },
            urlRegex:
                /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
        };
    },

    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },

        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },

        agencyName() {
            return this.$store.getters.getAgencyName;
        },

        is_file_option_computed() {
            if (this.is_has_signed_sow) {
                if (this.is_file_option) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },

        getCurrentDealId() {
            return (
                this.$store.getters.getSalesPages(
                    this.$store.getters.getDealSalesIndex
                ).deal_id || null
            );
        },

        sowIndex() {
            return this.$store.getters.getCurrentIndexSOW;
        },

        upsellIndex() {
            return this.$store.getters.getCurrentIndexSOW;
        },

        isEditUpsell() {
            return this.$store.getters.getIsEditUpsell;
        },
        currentDate() {
            return moment().format("MMDDYYYY");
        },
    },

    mounted() {
        this.initDatePicker();
        this.initValidDatePicker();
        this.initFilePicker();

        this.getData();

        scrollToTop();

        setTimeout(() => {
            reInitAllTooltips();
        }, 750);
    },

    methods: {
        async getData() {
            await axios
                .post("/api/wizard/getList", {
                    page: "new_sow",
                    deal_id: this.getCurrentDealId,
                    sow_index: this.isEditUpsell
                        ? this.sowIndex
                        : this.sowIndex + 1,
                })
                .then((res) => {
                    this.new_sow.title = res.data.page.sow_title;
                    if (res.data.page.sow_draft) {
                        this.new_sow.date = res.data.page.sow_draft.date;
                        this.new_sow.url = res.data.page.sow_draft.url;
                        this.new_sow.is_upload_later =
                            res.data.page.sow_draft.is_upload_later;
                        this.new_sow.description =
                            res.data.page.sow_draft.description;
                        this.new_sow.title = res.data.page.sow_draft.name;
                        this.new_sow.valid_date =
                            res.data.page.sow_draft.valid_date;
                        if (res.data.page.sow_draft.type === "file") {
                            this.new_sow.filename =
                                res.data.page.sow_draft.file;
                        } else {
                            this.is_file_option = false;
                        }

                        if (res.data.page.sow_draft.is_upload_later) {
                            this.is_has_signed_sow = "yes";
                            this.is_file_option = "later";
                        }

                        this.is_new_deal = res.data.page.is_new_deal || false;
                    }
                })
                .catch((err) => console.log("err getData sow", err));
        },
        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },
        initValidDatePicker() {
            const node__datepicker = this.$refs.valid_datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.new_sow.date = date;
            }
        },
        onChangeValidDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.new_sow.valid_date = date;
            }
        },

        initFilePicker() {
            const inputField = this.$refs.filepicker;

            if (!inputField) {
                return;
            }

            const button = inputField.querySelector("button");
            const input = inputField.querySelector("input");
            const filenameNode = inputField.querySelector("span.filename");

            if (button && input) {
                button.addEventListener("click", () => {
                    input.click();
                });
            }

            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    this.new_sow.filename = filename;
                    //filenameNode.innerHTML = filename;
                    this.new_sow.file = file[0];
                }
            });
        },
        pickFile() {
            let input = this.$refs.fileInput;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.readAsDataURL(file[0]);
                this.new_sow.file = file[0];
            }
        },

        validateFields() {
            if (this.is_file_option === "later") return;

            this.errors.date = null;
            this.errors.title = null;
            this.errors.file = null;
            this.errors.type = null;
            this.errors.url = null;
            this.errors.valid_date = null;

            if (!this.new_sow.title) {
                this.errors.title = "Required";
            }

            if (!this.new_sow.date) {
                this.errors.date = "Required";
            }
            if (
                !this.is_file_option &&
                this.new_sow.url &&
                !this.urlRegex.test(this.new_sow.url)
            ) {
                this.errors.url = "Invalid URL";
            }
            if (
                this.new_sow.date &&
                this.new_sow.valid_date &&
                new Date(this.new_sow.date) > new Date(this.new_sow.valid_date)
            ) {
                this.errors.valid_date = "Invalid valid date";
            }
        },

        onSaveSow() {
            try {
                this.validateFields();

                if (
                    this.is_has_signed_sow &&
                    (this.errors.date ||
                        this.errors.file ||
                        this.errors.type ||
                        this.errors.url ||
                        this.errors.valid_date)
                ) {
                    return;
                }

                if (
                    !this.is_has_signed_sow &&
                    (this.errors.title ||
                        this.errors.date ||
                        this.errors.valid_date)
                ) {
                    return;
                }
                this.isLoading = true;
                const formData = new FormData();

                const data = {
                    name: this.new_sow.title,
                    date: this.new_sow.date === null ? "" : this.new_sow.date,
                    url: this.new_sow.url ? this.new_sow.url : "",
                    description: this.description,
                    deal_id: this.getCurrentDealId,
                    type: this.is_file_option ? "file" : "url",
                    is_upload_later: this.is_file_option === "later",
                    is_file: this.is_file_option,
                    valid_date: this.new_sow.valid_date,
                    sow_index: this.isEditUpsell
                        ? this.sowIndex
                        : this.sowIndex + 1,
                    is_new_deal: this.is_new_deal,
                };
                formData.append("action", "createSow");
                formData.append("data", JSON.stringify(data));
                formData.append(
                    "file",
                    this.new_sow.file === null ? "" : this.new_sow.file
                );

                axios
                    .post("api/wizard/updateDraft", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then(() => {
                        if (!this.isEditUpsell) {
                            this.$store.commit(
                                "setIndexSOW",
                                this.sowIndex + 1
                            );
                            this.$store.commit(
                                "setIndexUpsell",
                                this.upsellIndex + 1
                            );
                        }
                        //this.$toast.success("SOW has been created!");
                        this.onChangeSection(SECTIONS.UPSELL, SECTIONS.SOW);
                    })
                    .catch((err) => {
                        this.$toast.error("Something went wrong!");
                        console.log("ERROR addSOWFile", err);
                    })
                    .finally(() => (this.isLoading = false));
            } catch (err) {
                console.error("Error in SOW.vue - onSaveSow", err);
            }
        },
        onHandleUploadLater() {
            this.is_has_signed_sow = null;
            this.is_upload_later = true;
        },
    },
};
</script>
